module.exports = __webpack_public_path__ + "fonts/rubik-light-webfont.8db85fdc.8db85fdc.ttf";